import React from "react";
import { useCallback, useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLenis } from "@studio-freight/react-lenis";

// styles
import styles from "./index.module.scss";
import classNames from "classnames/bind";
const cn = classNames.bind(styles);

const AccordionItem = ({
  question,
  answer,
  title,
  text,
  ...restProps
}) => {

  const [isOpen, setIsOpen] = useState(false);
  const lenis = useLenis();

  const resizeLenis = useCallback(() => {
    if (lenis && typeof lenis.resize === "function") {
      requestAnimationFrame(() => lenis.resize());
    }
  }, [lenis]);

  useEffect(() => {
    resizeLenis();
  }, [isOpen, resizeLenis]);

  const containerClasses = cn("container", {
    "opened": isOpen
  });

  return (
    <motion.div className={cn("wrapper")}
      onClick={() => setIsOpen(!isOpen)} tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && setIsOpen(!isOpen)}
    >
      <AnimatePresence onExitComplete={resizeLenis}>
        <motion.div
          key="question"
          className={containerClasses}
        >
          <motion.div className={cn("title")}>
            <h3>{title}</h3>
          </motion.div>
          <div className={cn("icon")}>
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
              <line
                y1="9.7207" x2="21" y2="9.7207" stroke="currentColor" />
              <motion.line
                initial={false}
                animate={{ rotate: isOpen ? 90 : 0 }}
                transition={{ type: 'keyframes' }}
                x1="10.5" y1="20.2207" x2="10.5" y2="0.220703" stroke="currentColor"
              />
            </svg>
          </div>
        </motion.div>

        {isOpen && (
          <motion.div
            key="answer"
            initial={{ opacity: 0, height: 0 }}
            animate={{
              opacity: 1,
              height: "auto",
              transition: {
                duration: 0.5,
                ease: "easeOut",
                opacity: {
                  delay: .3,
                  duration: .6

                }
              },
            }}
            exit={{
              opacity: 0,
              height: 0,
              transition: {
                duration: 0.25,
                ease: "easeOut",
                type: 'keyframes'
              },
            }}
            onAnimationComplete={resizeLenis}
            className={cn("text")}
          >
            {Array.isArray(text) ? (
              <ul>
                {text.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            ) : (
              <p>{text}</p>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default AccordionItem;
